import React from 'react';
import { Timeframe, ALL_TIMEFRAMES } from '../types';

interface TimeframeSelectorProps {
  selected: Timeframe[];
  onChange: (selected: Timeframe[]) => void;
  error?: string;
}

const DISPLAY_LABELS: Record<Timeframe, string> = {
  '1m': '1min',
  '5m': '5min',
  '15m': '15min',
  '30m': '30min',
  '45m': '45min',
  '1h': '1h',
  '2h': '2h',
  '3h': '3h',
  '4h': '4h',
  '6h': '6h',
  '8h': '8h',
  '12h': '12h',
  '1d': '1d',
  '2d': '2d',
  '3d': '3d',
  '1w': '1w',
  '2w': '2w',
  '1M': '1M',
};

function TimeframeSelector({
  selected,
  onChange,
  error,
}: TimeframeSelectorProps) {
  const toggle = (tf: Timeframe) => {
    if (selected.includes(tf)) {
      onChange(selected.filter((t) => t !== tf));
    } else {
      onChange([...selected, tf]);
    }
  };

  return (
    <div className="pq-field">
      <label className="pq-label">
        Timeframe <span className="pq-required">*</span>
      </label>
      <div className="pq-tf-grid">
        {ALL_TIMEFRAMES.map((tf) => {
          const isActive = selected.includes(tf);
          return (
            <button
              key={tf}
              type="button"
              className={`pq-tf-pill ${isActive ? 'active' : ''}`}
              onClick={() => toggle(tf)}
            >
              {DISPLAY_LABELS[tf]}
            </button>
          );
        })}
      </div>
      {error && <span className="pq-error pq-error--animate">{error}</span>}
    </div>
  );
}

export default TimeframeSelector;
